import { useAppState } from "../context/store";

const useSelf = () => {
  const { user } = useAppState();

  return user;
};

export default useSelf;
